import { ResearchedTransactionVm } from './researched-transaction-view-model';

export class ResearchedTransactionAccountVm extends Array<ResearchedTransactionVm> {
    constructor(public accountTransactions: ResearchedTransactionVm[]) {
        super(...accountTransactions);
    }

    public get accountName() {
        const [firstTransaction] = this;
        return `${firstTransaction.accountName} `;
    }

    public get accountNumber() {
        const [firstTransaction] = this;
        return firstTransaction.accountNumber;
    }

    public get transactionCount() {
        return this.accountTransactions.length;
    }

    public get transactions() {
        return this.accountTransactions;
    }
}
